import { render } from "./Interest.vue?vue&type=template&id=4c79c7ac"
import script from "./Interest.vue?vue&type=script&lang=ts"
export * from "./Interest.vue?vue&type=script&lang=ts"
script.render = render

export default script